<app-sign-out #signOutModal></app-sign-out>
<div class="content content-md settings-content">
  <div class="scroll-content-nosearch settings-scroll-content">
    <div id="content-list" class="list list-md">
      <div class="item item-md list-header list-header-md button-shade">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <label class="label label-md width-100">{{ getLabelTranslation("Settings") }}</label>
            <div class="arrow-container width-100">
              <div class="arrow-wrapper button-clear-md item-button button-md">
                <img src="/assets/img/cog.svg"
                  class="icon icon-md icon-md-primary item-icon app-icon-small"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (showClientSelection()) {
        <button class="item item-block item-md" id="ClientsButton" (click)="onNavigate(routes.clientSelection)"
          >
          <div class="item-inner">
            <img src="/assets/img/people.svg" class="icon icon-md icon-md-primary item-icon app-icon"/>
            <div class="input-wrapper width-100">
              <div class="list-label label label-md width-100 padding-right-5 padding-left-5">
                <div class="ellipses-label">{{ getLabelTranslation('Client_Selection') }}</div>
              </div>
              <app-item-arrow></app-item-arrow>
            </div>
            <div class="button-effect"></div>
          </div>
        </button>
      }
      @if (hasCustomerSelection()) {
        <button class="item item-block item-md" id="CustomersButton" (click)="onNavigate(routes.customerSelection)"
          >
          <div class="item-inner">
            <img src="/assets/img/people.svg" class="icon icon-md icon-md-primary item-icon app-icon"/>
            <div class="input-wrapper width-100">
              <div class="list-label label label-md width-100 padding-right-5 padding-left-5">
                <div class="ellipses-label">{{ getLabelTranslation('Customer_Selection') }}</div>
              </div>
              <app-item-arrow></app-item-arrow>
            </div>
            <div class="button-effect"></div>
          </div>
        </button>
      }
      <ng-container *featureFlag="'flagEnableCommissionEstimates'">
        @if (showEstimates()) {
          <button class="item item-block item-md" id="EstimateButton" (click)="onNavigate(routes.estimateSettings)">
            <div class="item-inner">
              <img src="/assets/img/percent.svg" class="icon icon-md icon-md-primary percent-icon app-icon"/>
              <div class="input-wrapper width-100">
                <div class="list-label label label-md width-100 padding-right-5 padding-left-5">
                  <div class="ellipses-label">{{ commissionEstimateButtonText() }}</div>
                </div>
                <app-item-arrow></app-item-arrow>
              </div>
              <div class="button-effect"></div>
            </div>
          </button>
        }
      </ng-container>
      <button class="item item-block item-md" id="LocationButton" (click)="onNavigate(routes.locationSettings)">
        <div class="item-inner">
          <img src="/assets/img/navigate.png" class="img-navigate"/>
          <div class="input-wrapper width-100 padding-left-5">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation('Geography_Selection') }}</div>
            </div>
            <app-item-arrow></app-item-arrow>
          </div>
          <div class="button-effect"></div>
        </div>
      </button>
      <button class="item item-block item-md" id="SortButton" (click)="onNavigate(routes.productSortSettings)">
        <div class="item-inner">
          <img src="/assets/img/sort.svg" class="img-navigate"/>
          <div class="input-wrapper width-100 padding-left-5">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation('Product_Types_Sort') }}</div>
            </div>
            <app-item-arrow></app-item-arrow>
          </div>
          <div class="button-effect"></div>
        </div>
      </button>
    </div>
    <div id="content-list-information" class="list list-md">
      <div class="item item-md list-header list-header-md button-shade">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <label class="label label-md width-100">{{ getLabelTranslation('Information') }}</label>
            <div class="arrow-container" style="width: 100px">
              <div class="arrow-wrapper button-clear-md item-button button-md">
                <img src="/assets/img/information.svg"
                  class="icon icon-md icon-md-primary item-icon app-icon-small"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation("User") }} <strong
              id="settings-information-username">{{ username }}</strong></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation("Client") }} <strong
              id="settings-information-client">{{ clientName }}</strong></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation("Version") }} <strong
              id="settings-information-version">{{ softwareVersion }}</strong></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label">{{ getLabelTranslation("Data_Refreshed") }} <strong
              id="settings-information-date">{{ updatedTime() | localizedDate }}</strong></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label"><a (click)="openDisclaimer()">{{ 'main.disclaimers.competitive.settings_button' | translate }}</a></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
      <div class="item item-block item-md">
        <div class="item-inner">
          <div class="input-wrapper width-100">
            <div class="list-label label label-md width-100">
              <div class="ellipses-label"><a
                href="https://rouseservices.atlassian.net/wiki/spaces/AD/pages/2745040939/Rates+Availability+User+Guide"
              target="_blank">{{ getLabelTranslation("User_Guide") }}</a></div>
            </div>
          </div>
          <div class="button-effect"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer footer-md settings-footer">
  <button class="button button-md button-default button-default-md button-block button-block-md button-md-secondary width-100"
    (click)="onSignOutClick()">
    <span class="button-inner">{{ getLabelTranslation('Sign_out') }}</span>
    <div class="button-effect"></div>
  </button>
</div>
